<div class="skl-readiness-history" aria-busy="true" aria-label="Loading modernization readiness job history">
  <div class="skl-card">
    <div class="skl-card__body">
      <div class="skl-table-wrap">
        <div class="table-responsive">
          <table class="skl-table">
            <colgroup>
              <col style="width: 10%">
              <col style="width: 13%">
              <col style="width: 12%">
              <col style="width: 13%">
              <col style="width: 12%">
              <col style="width: 16%">
              <col style="width: 14%">
              <col style="width: 10%">
            </colgroup>
            <thead>
              <tr>
                @for (col of cols; track col) {
                  <th>
                    <app-skeleton [width]="col === 1 ? '48%' : col === 3 ? '54%' : col === 6 ? '52%' : col === 7 ? '40%' : col === 8 ? '38%' : '64%'" height="12px" borderRadius="3px" marginBottom="0"></app-skeleton>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row) {
                <tr>
                  @for (col of cols; track col) {
                    <td [class.skl-cell--top]="col === 6 || col === 7">
                      @if (col === 3) {
                        <app-skeleton width="84px" height="20px" borderRadius="10px" marginBottom="0"></app-skeleton>
                      } @else if (col === 6) {
                        <div class="skl-results-stack skl-results-stack--badges">
                          <app-skeleton width="72px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                          <app-skeleton width="72px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                          <app-skeleton width="72px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                        </div>
                      } @else if (col === 7) {
                        <div class="skl-results-stack">
                          <app-skeleton width="68px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                          <app-skeleton width="68px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                          <app-skeleton width="64px" height="18px" borderRadius="10px" marginBottom="0"></app-skeleton>
                        </div>
                      } @else if (col === 8) {
                        <app-skeleton width="92px" height="30px" borderRadius="4px" marginBottom="0"></app-skeleton>
                      } @else {
                        <app-skeleton [width]="col === 1 ? (row % 2 === 0 ? '40%' : '32%') : col === 2 ? (row % 2 === 0 ? '60%' : '52%') : col === 4 ? (row % 2 === 0 ? '64%' : '52%') : col === 5 ? (row % 2 === 0 ? '46%' : '38%') : '48%'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="skl-pagination">
        <app-skeleton width="220px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        <div class="skl-pagination-buttons">
          @for (btn of [1, 2, 3, 4]; track btn) {
            <app-skeleton width="32px" height="32px" borderRadius="4px" marginBottom="0"></app-skeleton>
          }
        </div>
      </div>
    </div>
  </div>
</div>